import { Typography, Row, Col } from "antd";
import { fallbackString, formatDate } from "@/shared/utils";


interface ISroListContainer {
  sro?: {
    sroId?: string;
    sroHistoryId?: string;
    companyId?: string;
    sroType?: string;
    sroNumber?: string;
    sroDate?: string;
    sroIsserInn?: string;
    sroIsserOgrn?: string;
    sroIsserName?: string;
  }[];
}

export const SroListContainer = ({ sro }: ISroListContainer) => {
  const isHasSro = sro && sro.length > 0;
  if (isHasSro) {
    return sro.map((item) => {
      return (
        <>
          <Typography.Title
            level={5}
            style={{ fontWeight: 400, marginTop: 16 }}
          >
            {"СРО "}
            {item.sroType === "ENGINEERING"
              ? "Проектирование"
              : "Строительство"}
          </Typography.Title>
          <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
            <Col span={8} style={{ color: "#888" }}>
              Номер
            </Col>
            <Col span={16}>{fallbackString(item.sroNumber)}</Col>
            <Col span={8} style={{ color: "#888" }}>
              Дата
            </Col>
            <Col span={16}>{fallbackString(formatDate(item.sroDate))}</Col>
            <Col span={8} style={{ color: "#888" }}>
              Выдано
            </Col>
            <Col span={16}>{fallbackString(item.sroIsserName)}</Col>
            <Col span={8} style={{ color: "#888" }}>
              ИНН
            </Col>
            <Col span={16}>{fallbackString(item?.sroIsserInn)}</Col>
            <Col span={8} style={{ color: "#888" }}>
              ОГРН
            </Col>
            <Col span={16}>{fallbackString(item?.sroIsserOgrn)}</Col>
          </Row>
        </>
      );
    });
  }
  return (
    <>
      <Typography.Title level={5} style={{ fontWeight: 400 }}>
        {" "}
        Строительство
      </Typography.Title>
      <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
        <Col span={8} style={{ color: "#888" }}>
          Номер
        </Col>
        <Col span={16}>{fallbackString()}</Col>
        <Col span={8} style={{ color: "#888" }}>
          Дата
        </Col>
        <Col span={16}>{fallbackString()}</Col>
        <Col span={8} style={{ color: "#888" }}>
          Выдано
        </Col>
        <Col span={16}>{fallbackString()}</Col>
        <Col span={8} style={{ color: "#888" }}>
          ИНН
        </Col>
        <Col span={16}>{fallbackString()}</Col>
        <Col span={8} style={{ color: "#888" }}>
          ОГРН
        </Col>
        <Col span={16}>{fallbackString()}</Col>
      </Row>
    </>
  );
};
